var exports = {
  "V": "x61f99309--a2b1c1--message__meta",
  "x": "x61f99309--a2b1c1--status-icon",
};

module.exports = exports;
